import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Paper, Typography, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';
import DragIcon from '@material-ui/icons/DragHandle';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;

const getItemStyle = draggableStyle => ({
  userSelect: 'none',
  margin: `0 0 ${grid}px 0`,
  ...draggableStyle,
});

const getItemContentStyle = isDragging => ({
  background: isDragging ? '#C5CAE9' : '#fff',
});

const getListStyle = isDraggingOver => ({
  border: isDraggingOver ? '1px dashed #ccc' : 'none',
  padding: isDraggingOver ? 0 : 1,
  width: 250,
});

class FormRanking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: !props.disabled
        ? props.values
        : props.input.value.map(selected => ({
          value: selected,
          name: props.values.find(v => v.value === selected).name
        })),
    };
  }

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({ items }, this.props.input.onChange(items.map(item => item.value)));
  }

  render() {
    const { label, error, disabled } = this.props;

    return (
      <React.Fragment>
        {label && <Typography variant="caption" gutterBottom style={error ? {color: 'red'} : {}}>{label}</Typography>}
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable" isDropDisabled={disabled}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {this.state.items.map((item, index) => (
                  <Draggable key={item.value} draggableId={item.value} index={index} isDragDisabled={disabled}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(provided.draggableProps.style)}
                      >
                        <Paper
                          style={getItemContentStyle(snapshot.isDragging)}
                          elevation={snapshot.isDragging ? 8 : 1}
                        >
                          <ListItem dense>
                            <ListItemIcon>
                              <DragIcon />
                            </ListItemIcon>
                            <ListItemText primary={item.name} />
                          </ListItem>
                        </Paper>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </React.Fragment>
    );
  }
}

FormRanking.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  values: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

export default FormRanking;



// WEBPACK FOOTER //
// ./src/components/form/FormRanking.js